import { Link } from "react-router-dom";
import { ChevronRight, Timer } from "lucide-react";
import { useAuth } from "@/lib/auth";
import { useFetch } from "@/lib/hooks";
import { Empty, Loading, PageHeader, StatusBadge } from "@/components/common";

export default function Mechanic() {
  const { user } = useAuth();
  const { data, loading } = useFetch<any[]>("/mechanic/orders");
  return (
    <div>
      <PageHeader eyebrow={`Atelier · ${user?.name}`} title={user?.role === "mecanicien" ? "Mes véhicules" : "Vue atelier"} />
      {loading ? <Loading /> : !data?.length ? <Empty text="Aucun OR en cours pour vous" /> : (
        <div className="grid gap-6 md:grid-cols-2" data-testid="mechanic-orders">
          {data.map((o) => {
            const done = o.tasks.filter((t: any) => t.done).length;
            return (
              <Link key={o.id} to={`/atelier/${o.id}`} className="plate group relative block rounded-sm p-7 transition-colors hover:border-primary/60 fade-up" data-testid={`mechanic-order-${o.id}`}>
                {o.running && <span className="absolute right-5 top-5 flex items-center gap-1.5 text-sm font-semibold text-amber-300"><Timer className="h-4 w-4 animate-pulse" />Chrono</span>}
                <div className="font-mono-data text-3xl font-bold tracking-tight">{o.plate}</div>
                <div className="mt-1 text-base text-muted-foreground">{o.vehicle_label}</div>
                <div className="mt-6 flex items-center justify-between">
                  <div className="flex items-center gap-3"><StatusBadge status={o.status} /><span className="font-mono-data text-sm">{o.number}</span></div>
                  <span className="text-sm text-muted-foreground">{done}/{o.tasks.length} tâches</span>
                </div>
                <div className="mt-4 h-1.5 w-full bg-muted"><div className="h-full bg-primary transition-[width]" style={{ width: `${o.tasks.length ? (done / o.tasks.length) * 100 : 0}%` }} /></div>
                <ChevronRight className="absolute bottom-7 right-5 h-6 w-6 text-muted-foreground transition-transform group-hover:translate-x-1" />
              </Link>
            );
          })}
        </div>
      )}
    </div>
  );
}
